<div class="dx-viewport vh-100">
	<lib-toastify-toast-container [position]="'bottom-right'" [autoCloseSuccess]="2500"></lib-toastify-toast-container>
	<div class="app" *ngIf="!showLoginForm">
		<aside class="sidebar" [class.collapsed]="isDrawerOpen" *ngIf="showSidebar && isDesktop"
			[class.stagingSidebar]="staging">
			<!-- Toggle Button -->
			<div class="sb-logo-section-toggle">
				<div class="sidebar-toggle">
					<button (click)="toggleSideDrawer()">
						<i class="fas" [class.fa-angle-left]="!isDrawerOpen" [class.fa-angle-right]="isDrawerOpen" style="padding-left:-20px"></i>
					</button>
				</div>
			</div>

			<!-- Logo Section -->
			<div *ngIf="staging && !isDrawerOpen" class="staging-warning"><i class="fas fa-dot-circle"></i> STAGING SYSTEM</div>
			<div *ngIf="staging && isDrawerOpen" class="staging-warning"><i class="fas fa-dot-circle"></i></div>
			<div class="sb-logo-section">
				<img class="image-fluid" [style.width]="isDrawerOpen ? '90%' : '75%'" [style.transform]="isDrawerOpen ? 'rotate(270deg)' : ''" style="margin-left:auto; margin-right:auto" src="../../../assets/Logo.png">
			</div>
			<!-- Navigation Menu -->
			<nav class="nav-menu">
				<ul>
					<li *ngFor="let item of menuItems" [class.active]="isActiveRoute(item.route)"
						(click)="navigate(item)" [attr.title]="isDrawerOpen ? item.text : null">
						<i [class]="'fas ' + item.icon"></i>
						<span class="menu-text" [class.hide]="isDrawerOpen">{{ item.text }}</span>
					</li>
				</ul>
			</nav>

			<!-- User Profile -->
			<div class="user-profile" [class.collapsed]="isDrawerOpen">
				<div class="profile-icons">
					<div class="flip-wrapper">
						<div class="flip-card">
							<div class="flip-front">
								<img [src]="avatarUrl" alt="User" />
							</div>
							<div class="flip-back" (click)="navigateUrl('admin/user-settings')" [attr.title]="isDrawerOpen ? 'Settings' : null">
								<i class="fas fa-cog" style="color:white"></i>
							</div>
						</div>
					</div>
				</div>

				<div class="user-info" [class.hide]="isDrawerOpen">
					<p>{{ userProfile.firstName }} {{ userProfile.lastName }}</p>
				</div>

				<i class="fas fa-sign-out-alt logout-icon" (click)="logout()" [attr.title]="isDrawerOpen ? 'Logout' : null"></i>
			</div>

			<!-- <div class="user-info" [class.hide]="isDrawerOpen">
					<p>{{ userProfile.firstName }} {{ userProfile.lastName }}</p>
				</div>

				<i class="fas fa-sign-out-alt logout-icon" (click)="logout()"
					[attr.title]="isDrawerOpen ? 'Logout' : null"></i>
			</div>
			<div class="user-profile">
				<div class="flip-wrapper">
					<div class="flip-card">
						<div class="flip-front">
							<img [src]="avatarUrl" alt="User" />
						</div>
						<div class="flip-back" (click)="navigateUrl('admin/user-settings')" [attr.title]="isDrawerOpen ? 'Settings' : null">
							<i class="fas fa-cog" style="color:white;"></i>
						</div>
					</div>
				</div>

				<div class="user-info" [class.hide]="isDrawerOpen">
					<p>{{ userProfile.firstName }} {{ userProfile.lastName }}</p>
				</div>

				<i class="fas fa-sign-out-alt" (click)="logout()" style="color:red"
					[attr.title]="isDrawerOpen ? 'Logout' : null"></i> -->
		</aside>



		<div class="main-content">
			<!-- Mobile Header/Menu -->
			<div class="mobile-header" *ngIf="!isDesktop && !disableMobileMenu">
				<div class="mobile-header-bar">
					<img class="mobile-logo" src="../../../assets/Logo.png" alt="Logo" />
					<button (click)="toggleMobileMenu()" class="menu-toggle">
						<i class="fas" [class.fa-bars]="!mobileMenuOpen" [class.fa-times]="mobileMenuOpen"></i>
					</button>
				</div>
				<div class="mobile-dropdown-wrapper" [class.open]="mobileMenuOpen">
					<div class="mobile-dropdown">
						<ul class="mobile-nav-list">
							<li *ngFor="let item of menuItems" (click)="navigate(item); toggleMobileMenu()">
								<i [class]="'fas ' + item.icon"></i> {{ item.text }}
							</li>
							<li (click)="navigateUrl('admin/user-settings'); toggleMobileMenu()">
								<i class="fas fa-cog"></i> User Settings
							</li>
							<li (click)="logout()">
								<i class="fas fa-sign-out-alt" style="color:red;"></i> <span
									style="color:red">Logout</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div id="content">
				<div *ngIf="displayBanner === true" id="adminBanner">{{bannerText}}</div>
				<router-outlet></router-outlet>
				<modal></modal>
			</div>
		</div>

		<!-- Go To Dialog -->
		<div class="goto-overlay" *ngIf="showGoToDialog" (click)="closeGoToDialog()">
			<div class="goto-dialog" (click)="$event.stopPropagation()">
				<div class="goto-header">
					<i class="fas fa-search"></i>
					<span>Go To</span>
					<span class="goto-shortcut">Ctrl+G</span>
				</div>
				<div class="goto-pills">
					<button *ngFor="let et of goToEntityTypes" class="goto-pill" [class.active]="goToEntityType === et.menuRoute" (click)="goToEntityType = et.menuRoute">{{ et.label }}</button>
				</div>
				<div class="goto-input-row">
					<input type="text" class="goto-input goto-id-input" [(ngModel)]="goToId" (keydown.enter)="goToEntity()" placeholder="Enter ID..." />
					<button class="goto-go-btn" [disabled]="!goToId" (click)="goToEntity()"><i class="fas fa-arrow-right"></i></button>
				</div>
			</div>
		</div>

		<!-- Part Search Dialog -->
		<div class="goto-overlay" *ngIf="showPartSearch" (click)="closePartSearch()">
			<div class="goto-dialog" (click)="$event.stopPropagation()">
				<div class="goto-header">
					<i class="fas fa-search"></i>
					<span>Part Search</span>
					<span class="goto-shortcut">Ctrl+K</span>
				</div>
				<div class="goto-input-row" style="padding-top: 12px;">
					<input type="text" class="goto-input part-search-input" [(ngModel)]="partSearchTerm" (ngModelChange)="onPartSearchInput()" placeholder="Search by part number..." />
				</div>
				<div class="part-search-results" *ngIf="partSearchResults.length > 0">
					<div class="part-search-item" *ngFor="let part of partSearchResults" (click)="goToPart(part)">
						<img *ngIf="part.tileImageUrl" class="part-search-img" [src]="part.tileImageUrl" />
						<div *ngIf="!part.tileImageUrl" class="part-search-img-placeholder"><i class="fas fa-cube"></i></div>
						<strong>{{ part.partNumber }}</strong>
						<span class="part-search-desc">{{ part.description }}</span>
					</div>
				</div>
				<div class="part-search-empty" *ngIf="partSearchTerm.length >= 2 && partSearchResults.length === 0">
					No parts found
				</div>
			</div>
		</div>

	</div>
	<!-- LOGIN PAGE -->
	<div class="login-wrapper login-screen" *ngIf="showLoginForm">
		<div class="login-card">
			<!-- Logo Section -->
			<div class="logo-section">
				<img class="image-fluid" style="width: 50%;" src="../../../assets/Logo.png">
			</div>

			<!-- Login Form -->
			<div class="login-form">
				<h2 style="color:#344281; margin-bottom:0">Welcome to Flow <span *ngIf="staging"
						style="color:red">Staging</span></h2>
				<h2>Please Sign In</h2>
				<form (submit)="login()" novalidate>
					<div class="form-group">
						<label for="email">Email Address</label>
						<div class="input-icon-wrapper">
							<input type="email" id="email" [(ngModel)]="loginDetails.login" name="email" required
								placeholder="Enter your email" />
							<i class="fas fa-envelope"></i>
						</div>
					</div>

					<div class="form-group">
						<label for="password">Password</label>
						<div class="input-icon-wrapper">
							<input type="password" id="password" [(ngModel)]="loginDetails.password" name="password"
								required placeholder="Enter your password" />
							<i class="fas fa-lock"></i>
						</div>
					</div>

					<div class="form-footer">
						<a class="forgot-password" href="/admin/forgotPassword">Forgot password?</a>
					</div>

					<button type="submit" class="login-button">Sign In</button>
				</form>

				<div class="additional-options">
					<p>Don't have an account? <span class="admin-contact">Contact Administrator</span></p>
				</div>
			</div>

			<!-- Footer -->
			<div class="footer">
				<p>{{copyright}}</p>
			</div>
		</div>
	</div>
</div>